require('../sass/app.scss');
require('materialize-css');
require('../../node_modules/ionicons/dist/scss/ionicons.scss');


//require('./filters');


//////////////////
// WEBPACK FOOTER
// ./src/js/bootstrap.js
// module id = 34
// module chunks = 0